import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import moment from 'moment-timezone';
import NumbersHelper from '../../helpers/numbers';

class InvoicesComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { items: { invoices } } = this.props;
    return (
      <div className="row justify-content-center">
        <div className="invoices-modal-main">
          <span className="title-order-details">
            <Translate value="invoice" />
          </span>
          {invoices.map(invoice => (
            <React.Fragment>
              <hr />
              <span className="title-order-details">
                <Translate value="invoiceText" />
                {' '}
                {invoice.number}
              </span>
              <table className="table table-mini-cart">
                <tbody>
                  <tr>
                    <td>
                      <Translate value="code" />
                      :
                      {' '}
                      <strong>{invoice.purchaseId}</strong>
                    </td>

                    <td>
                      <Translate value="invoiceNumber" />
                      :
                      {' '}
                      <strong>{invoice.number}</strong>
                    </td>


                    <td>
                      <Translate value="value" />
                      :
                      {' '}
                      <strong>{NumbersHelper.toCurrency(invoice.value)}</strong>
                    </td>

                  </tr>
                  <tr>
                    <td>
                      <Translate value="quantity" />
                      {' '}
                      <strong>{invoice.totalItems}</strong>
                    </td>
                    <td>
                      Serie:
                      {' '}
                      <strong>{invoice.serie}</strong>
                    </td>
                    <td>
                      <Translate value="buyDate" />
                      :
                      {' '}
                      <strong>{moment(invoice.date).format('HH:mm DD/MM/YYYY')}</strong>
                    </td>
                  </tr>
                  <tr>

                    <td>
                      <Translate value="conveyor" />
                      {' '}
                      <strong>{invoice.conveyor}</strong>
                    </td>

                    <td>
                                    CGC:
                      {' '}
                      <strong>{invoice.cgc}</strong>
                    </td>

                    <td>
                      <Translate value="paymentCondition" />
                      :
                      {' '}
                      <strong>{invoice.paymentCondition}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h4>
                        <Translate value="productBought" />
                      </h4>
                    </td>
                  </tr>

                  {invoice.items && invoice.items.map(item => (
                    <tr key={item.code}>
                      <td className="product-col">
                        <div>
                          <p className="product-title">
                            {item.description}
                          </p>
                          <span className="product-qty">
                            <Translate value="quantity" />
                            {' '}
                            {item.quantity}
                          </span>
                        </div>
                      </td>
                      <td className="price-col">
                        {NumbersHelper.toCurrency(item.unitPrice.replace(',', '.'))}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <td className="font-weight-899"><Translate value="total" /></td>
                    <td className="font-weight-899">
                      {NumbersHelper.toCurrency(invoice.value)}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </React.Fragment>
          ))}

        </div>
      </div>
    );
  }
}


export default (InvoicesComponent);
